var React = require('react');

function SbCheck (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"#58B76A"},[React.createElement("path",{"d":"M32 0C14.356 0 0 14.356 0 32s14.356 32 32 32 32-14.356 32-32S49.644 0 32 0zm0 61.536C15.715 61.536 2.464 48.285 2.464 32 2.464 15.715 15.715 2.464 32 2.464c16.285 0 29.536 13.25 29.536 29.536C61.535 48.285 48.285 61.536 32 61.536zm0 0","key":0}),React.createElement("path",{"d":"M47.078 18.876L28.16 40.155l-11.395-9.116a1.231 1.231 0 00-1.731.192 1.24 1.24 0 00.192 1.731l12.307 9.843c.229.18.5.271.769.271.343 0 .68-.138.926-.415l19.687-22.15a1.222 1.222 0 00-.103-1.737 1.218 1.218 0 00-1.734.102zm0 0","key":1})]));
}

SbCheck.defaultProps = {"width":"64","height":"64","viewBox":"0 0 64 64"};

module.exports = SbCheck;

SbCheck.default = SbCheck;
